import Color, { alpha } from "../../views/private/styled";
import styled from "styled-components";
import { FadeAnimation } from "../../views/private/animations";


const Overlay = styled("div")<{css? : string}>`
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background: ${ alpha(Color.black, 0.7) };
    position: fixed;

    animation: ${FadeAnimation} 0.2s linear 1;

    ${props => props.css ?? ""}
`
export default Overlay;

